import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import React from "react";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import {PostStatus, PostType} from "../../../ts/manager/post/PostManager";
import {getManager} from "../../../ts/manager/Manager";
import ApplicationResponseForm from "./partial/ApplicationResponseForm";
import Error404Partial from "../../partial/status/Error404Partial";

const ApplicationsPage = (props:IRouteProps) =>
{
    const postType:PostType|null = getManager().navigation.model.routeIDs.post_type ?? null;
    const postID = getManager().navigation.model.routeIDs.post_id ?? 0;
    const organisationID = getManager().user.organisationID
    if(((postType !== "project") && (postType !== "offer")) || !postID || !organisationID){
        return <Error404Partial {...props} />
    }

    const postDataModel = getModelFactory().postData.getPostDataModel(postType, true);
    const postDataChoice = postDataModel.choices[postID] ?? null;
    const postStatus:PostStatus|null = postDataChoice?.postStatus ?? null;
    const routeViewChoice = getModelFactory().getEntryRouteChoice(postType, postID, false, postStatus)
    const editViewChoice = getModelFactory().getEntryRouteChoice(postType, postID, true);
    const postConfig = getManager().post.config[postType];

    return <>
        <section className="content-block py-0">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {!!routeViewChoice && <>
                            <RouteChoiceButton
                                routeChoice={routeViewChoice }
                                label={"View " + postConfig.name}
                                className="btn edit-btn reduced me-1"
                            />
                        </>}
                        {!!editViewChoice && <>
                            <RouteChoiceButton
                                routeChoice={editViewChoice }
                                label={"Edit " + postConfig.name}
                                className="btn edit-btn reduced"
                            />
                        </>}
                    </div>
                </div>
            </div>
        </section>
        <ApplicationResponseForm
            routeProps={props}
            organisationID={organisationID}
            postType={postType}
            postID={postID}
        />
    </>
}

export default ApplicationsPage;